import { Alert, Props } from '../../alert/Alert';

export const AlertWrapper = ({ title, subtitle, level }: Props) => {
  return (
    <div className="payment-form__alert" data-testid="payment-form-alert">
      <Alert title={title} subtitle={subtitle} level={level} />
    </div>
  );
};
